.movers {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.moversLabel {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--soft);
}

.moversEmpty {
  font-size: 0.88rem;
  color: var(--muted);
}

.moverList {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.moverRow {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr) 56px;
  align-items: center;
  gap: 10px;
}

.moverName {
  font-size: 0.9rem;
  color: var(--soft);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Diverging track: bars grow out from a centre axis, gainers right, losers left */
.moverTrack {
  position: relative;
  height: 8px;
  border-radius: 999px;
  background: var(--surface-2);
}

.moverAxis {
  position: absolute;
  left: 50%;
  top: -2px;
  bottom: -2px;
  width: 1px;
  background: var(--border-md);
}

.moverBar {
  position: absolute;
  top: 0;
  bottom: 0;
  border-radius: 999px;
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1), left 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.moverBarUp {
  background: var(--up);
}

.moverBarDown {
  background: var(--down);
}

.moverValue {
  font-size: 0.85rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.up {
  color: var(--up);
}

.down {
  color: var(--down);
}

@media (max-width: 480px) {
  .moverRow {
    grid-template-columns: 80px minmax(0, 1fr) 50px;
    gap: 8px;
  }
}
